module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('el-container', [_c('el-header', [_c('div', {
    staticClass: "search"
  }, [_c('header', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("| 筛选条件")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "输出类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "change": _vm.changeTransactionType
    },
    model: {
      value: (_vm.formInline.transactionType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transactionType", $$v)
      },
      expression: "formInline.transactionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "运费",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "额外费用",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "工单费",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "派送费",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运输类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.transportType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transportType", $$v)
      },
      expression: "formInline.transportType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "海运",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "空运",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "海运大件",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.formInline.checkedBatch),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedBatch", $$v)
      },
      expression: "formInline.checkedBatch"
    }
  }, _vm._l((_vm.batchArr), function(batchObj) {
    return _c('el-option', {
      key: batchObj.sendId,
      attrs: {
        "label": batchObj.remark,
        "value": batchObj.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "",
      "disabled": _vm.showWhichTable == 2,
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.statusType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "statusType", $$v)
      },
      expression: "formInline.statusType"
    }
  }, _vm._l((_vm.statusArr), function(statusObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": statusObj.name,
        "value": statusObj.value,
        "disabled": statusObj.value == 1 ||
          (statusObj.value == 2 && !!_vm.formInline.checkedBatch)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "派送点："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.formInline.deliverAddress),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "deliverAddress", $$v)
      },
      expression: "formInline.deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "人员："
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.checkedPerson),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedPerson", $$v)
      },
      expression: "formInline.checkedPerson"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.peopleArr), function(peopleObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": peopleObj.vipCode,
        "value": peopleObj.vipCode
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "search-icon",
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.showUserDialog
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "56px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("筛选数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总运费:"), _c('span', [_vm._v(_vm._s(_vm.freight))])])]) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总额外费用:"), _c('span', [_vm._v(_vm._s(_vm.extraPrice))])])]) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 3) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总工单费:"), _c('span', [_vm._v(_vm._s(_vm.demandMoney))])])]) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 4) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总派送费:"), _c('span', [_vm._v(_vm._s(_vm.deliveryPrice))])])]) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "margin-top": "100px",
      "box-sizing": "border-box"
    }
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(_vm.showWhichTable == 1) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 运单页")]) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 发货单页")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in",
    staticStyle: {
      "max-width": "1700px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [_c('el-table-column', {
    key: 1,
    attrs: {
      "prop": "orderNo",
      "label": "订单编号",
      "width": "160",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.orderNo) + "\n                ")]
      }
    }], null, false, 3318077970)
  }), _vm._v(" "), _c('el-table-column', {
    key: 12,
    attrs: {
      "min-width": "180",
      "align": "center",
      "prop": "expressNo",
      "label": "运单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n                    " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n                  ")]) : _vm._e(), _vm._v("\n\n                  " + _vm._s(scope.row.expressNo ? scope.row.expressNo : "") + "\n                ")]
      }
    }], null, false, 2997915901)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addTime",
      "label": "下单时间",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.addTime ? _vm.changeDate(scope.row.addTime, 1) : "") + "\n                ")]
      }
    }], null, false, 4135224054)
  }), _vm._v(" "), _c('el-table-column', {
    key: 3,
    attrs: {
      "prop": "arrProduct",
      "label": "名称",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n                    " + _vm._s(scope.row.goodName) + "\n                  ")])]
      }
    }], null, false, 3339316019)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.deliveryTitle) + "\n                ")]
      }
    }], null, false, 610745121)
  }), _vm._v(" "), _c('el-table-column', {
    key: 6,
    attrs: {
      "prop": "realName",
      "label": "客户",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.vipCode) + "\n                ")]
      }
    }], null, false, 3926535327)
  }), _vm._v(" "), _c('el-table-column', {
    key: 8,
    attrs: {
      "prop": "mobile",
      "width": "120",
      "label": "联系方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.sendRemark) + "\n                ")]
      }
    }], null, false, 3366488835)
  }), _vm._v(" "), _c('el-table-column', {
    key: 10,
    attrs: {
      "prop": "expressCompany",
      "width": "100",
      "label": "物流公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 11,
    attrs: {
      "prop": "orderNo",
      "align": "center",
      "width": "160",
      "label": "摘要"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n                    待入库\n                  ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    已入库\n                  ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    已出库\n                  ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    已结单\n                  ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n                    已取消\n                  ")]) : (scope.row.status == 6) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    已合箱\n                  ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    （中心仓）已入库\n                  ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    （中心仓）已出库\n                  ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    （派送）已入库\n                  ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#ffa500"
          }
        }, [_vm._v("\n                    可预约\n                  ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#008000"
          }
        }, [_vm._v("\n                    已预约\n                  ")]) : _vm._e()]
      }
    }], null, false, 3709828376)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n                ")]
      }
    }], null, false, 3897659740)
  }), _vm._v(" "), _c('el-table-column', {
    key: 13,
    attrs: {
      "label": "工单费（CAD）",
      "min-width": "140px",
      "align": "center",
      "prop": "demandMoney"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 14,
    attrs: {
      "label": "派送费(CAD)",
      "min-width": "140px",
      "align": "center",
      "prop": "deliveryPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 15,
    attrs: {
      "label": "额外费用（CAD）",
      "min-width": "160px",
      "align": "center",
      "prop": "extraPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n                ")]
      }
    }], null, false, 4265623366)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sendOrderList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货编号",
      "prop": "sendNo",
      "min-width": "220px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n                    " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sendNo ? scope.row.sendNo : ""))])]
      }
    }], null, false, 662158576)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单生成时间",
      "prop": "sendTime",
      "width": "160px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.sendTime ? _vm.changeDate(scope.row.sendTime) : ""))])]
      }
    }], null, false, 2563937936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showUserVipCode(scope.row.user) : ""))])]
      }
    }], null, false, 182391634)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showRealName(scope.row.user) : ""))])]
      }
    }], null, false, 3898529692)
  }), _vm._v(" "), _c('el-table-column', {
    key: 25,
    attrs: {
      "label": "订单数量",
      "prop": "orderCount",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 26,
    attrs: {
      "label": "实收费用 CAD",
      "prop": "amount",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "width": "120px",
      "align": "center",
      "prop": "userBalance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showBalance(scope.row.user) : ""))])]
      }
    }], null, false, 2388616455)
  }), _vm._v(" "), _c('el-table-column', {
    key: 28,
    attrs: {
      "label": "额外费用",
      "prop": "extraPrice",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 281,
    attrs: {
      "label": "派送费",
      "min-width": "100px",
      "align": "center",
      "prop": "deliveryPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 29,
    attrs: {
      "label": "批次",
      "prop": "remark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n                ")]
      }
    }], null, false, 4265623366)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "padding-right": "40px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginationsPerson.page_sizes,
      "page-size": _vm.paginationsPerson.page_size,
      "layout": _vm.paginationsPerson.layout,
      "total": _vm.paginationsPerson.total,
      "current-page": _vm.paginationsPerson.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChangePerson,
      "size-change": _vm.handleSizeChangePerson
    }
  }) : _vm._e()], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowUserDialog,
      "append-to-body": true,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowUserDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "roleData dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v("人员选择")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("客户/vipCode：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.roleInput),
      callback: function($$v) {
        _vm.roleInput = $$v
      },
      expression: "roleInput"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchRole
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.setRole
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTableRole",
    staticClass: "table",
    attrs: {
      "data": _vm.roleData,
      "border": "",
      "max-height": 580
    },
    on: {
      "select": _vm.selectRoleOnce,
      "selection-change": _vm.selectOptionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vipCode",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "background": "",
      "current-page": _vm.rolePaginations.page_index,
      "page-sizes": _vm.rolePaginations.page_sizes,
      "page-size": _vm.rolePaginations.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.rolePaginations.total
    },
    on: {
      "size-change": _vm.rHandleSizeChange,
      "current-change": _vm.rHandleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelRole()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.certainRole()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a74f111"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/statistical/cost.vue
// module id = 1244
// module chunks = 2